export enum ROUTES {
    ABOUT = '/about',
    ACCEPT_JURY_INVITE = '/jury/invite/:token',
    ACCOUNT = '/account',
    ACCOUNT_BILLING = '/account/billing',
    ACCOUNT_COMMUNICATIONS = '/account/communication',
    ACCOUNT_NOTIFICATIONS = '/account/notification',
    ACCOUNT_PREFERENCE = '/account/preference',
    ACCOUNT_PREFERENCES = '/account/preferences',
    ACCOUNT_SETTINGS = '/account/settings',
    ACCOUNT_SUBSCRIPTION = '/account/subscription',
    ACCOUNT_EXTERNAL_ACCOUNT = '/account/external',
    API_LOADER = '/api',
    AUDITION = '/audme',
    MANAGE_AUDITION = '/audme/:id/manage',
    AUDITION_DETAIL = '/audme/:auditionId?',
    COMING_SOON = '/comingsoon',
    COMPANY = '/company/:id',
    COOKIE_PREFERENCE = '/cookie-preference',
    COOKIES_POLICY = '/cookies',
    DASHBOARD = '/dashboard',
    DASHBOARD_LOYALTY_ADMIN = '/dashboard/loyalty',
    DASHBOARD_EVENTS = '/dashboard/events',
    DASHBOARD_HELP = '/dashboard/help',
    DASHBOARD_JURYDUTY = '/dashboard/jury',
    DASHBOARD_MAIN = '/dashboard/main',
    DASHBOARD_PROFILE = '/dashboard/profile',
    DASHBOARD_PROJECT = '/dashboard/project',
    DASHBOARD_SETTINGS = '/dashboard/settings',
    DASHBOARD_SUBMISSIONS = '/dashboard/submissions',
    DASHBOARD_TEAMS = '/dashboard/teams',
    DISCOVER = '/discover',
    ESALL_CONTESTS = '/esall-contests',
    ESCOMING_SOON = '/coming-soon',
    ESCONTEST = '/submissions',
    ESCONTEST_ENGAGE = '/campaign-metrics/:contestId?',
    ESDISCOVERY = '/campaigns',
    ESJOIN_CONTESTS = '/esjoin-contest',
    ESJURY_DUTY = '/jury-duty',
    ESJURY_DUTY_REVIEW = '/jury-duty/:contestId/review',
    ESLIVE_CONTESTS = '/eslive-contests',
    ESLOGIN = '/login',
    ESMY_PROFILE = '/:profileId?',
    ESMY_VIDEOS = '/projects',
    ESNEWPASSWORD = '/new-password/:token?',
    ESRESETPASSWORD = '/reset-password',
    ESSETTINGS = '/settings',
    ESSIGNUP = '/signup',
    ESTRENDING = '/trending',
    ESVIEW_CONTEST = '/campaign/:contestId?',
    ESWATCH_VIDEO = '/watch',
    SANDBOX = '/sandbox',
    SANDBOX_STUDIO = '/sandbox/studio',
    SANDBOX_COURSE = '/sandbox/course/:courseId',
    SANDBOX_PLAYER = '/sandbox/course/:courseId/lesson/:lessonId',
    EVENT = '/event/:contestId?',
    EVENT_DETAILS = '/event/:eventId?',
    EVENT_CUSTOM = '/:hostName/:contestId?',
    EXCEPTION = '*',
    MENU_DASHBOARD = '/menu-dashboard',
    WATCH = '/watch-share',
    TERMS_OF_USE = '/terms-of-use',
    FAQ = '/faq',
    /** Footer / marketing: advertise on Thspian (standalone page, same path as sidebar footer link). */
    ADVERTISE = '/advertise',
    FEED = '/campaigns',
    FORGOT_PASSWORD = '/forgotPassword',
    GIG = '/gig',
    GIG_DETAIL = '/gig/:gigId',
    HELP_CENTER = '/help-center',
    HOME = '/',
    LANDING = '/landing',
    LINKS = '/links',
    LOGIN_IN = '/login',
    PHONE_AUTHENTICATION = '/verify',
    PRIVACY_POLICY = '/privacy-policy',
    DELETE_ACCOUNT = '/delete-account',
    PROFILE = '/profile',
    REGISTER = '/register',
    SEARCH = '/search',
    SETTINGS = '/settings',
    SHOP = '/shop',
    SPLASH = '/splash',
    SUBMIT = '/submit',
    TALENTS = '/talents',
    USER = '/:profileId?',
    VERIFY_EMAIL = '/email-verify/:token',
    WINNERS = '/winners',
    EVENTS = '/events',
    CONTEST_SUBMISSIONS = '/campaign/:contestId/entries',
    MESSAGES = '/messages',
    MESSAGES_CONVERSATION = '/messages/:roomId',
    MANAGE_EVENT = '/event/:id/manage',
    MANAGE_CONTEST = '/campaign/:contestId/manage',
    MANAGE_SUBMISSION = '/submission/:submissionId/manage',
    SOCIAL_AUTH_PAGE = '/auth/:provider/callback',
    BUZZ_BRIDGE = '/buzzbridge/dashboard',
    /** Creator/influencer campaign hub (participant row). */
    BUZZ_BRIDGE_CAMPAIGN_WORKSPACE = '/buzzbridge/dashboard/campaigns/:campaignId/participant/:participantId',
    BUZZ_BRIDGE_CAMPAIGN_SUBMIT = '/buzzbridge/dashboard/campaigns/:campaignId/participant/:participantId/submit',
    BUZZ_BRIDGE_LANDING = '/buzzbridge',
    BUZZ_BRIDGE_DETAILS = '/buzzbridge/:campaignId',
    BUZZ_BRIDGE_REWARDS = '/buzzbridge/rewards',
    BUZZ_BRIDGE_REWARDS_NETWORK = '/buzzbridge/rewards/network',
    BUZZ_BRIDGE_REWARDS_MEMBER = '/buzzbridge/rewards/network/:referralId',
    BUZZ_BRIDGE_REWARDS_REDEEM = '/buzzbridge/rewards/redeem',
    UGC_CAMPAIGN_DETAIL = '/campaigns/:campaignId',
    /** Brand workspace (standalone layout, no main app sidebar) */
    BRAND = '/brand',
    BRAND_CAMPAIGNS = '/brand/campaigns',
    BRAND_CAMPAIGN_NEW = '/brand/campaigns/new',
    BRAND_CAMPAIGN_DETAIL = '/brand/campaigns/:campaignId',
    BRAND_CONTEST_MANAGE = '/brand/campaigns/contest/:contestId/manage',
    BRAND_CAMPAIGN_APPLICATIONS = '/brand/campaigns/:campaignId/applications',
    BRAND_CAMPAIGN_ACCEPTED_CREATORS = '/brand/campaigns/:campaignId/accepted',
    BRAND_CAMPAIGN_REPORT = '/brand/campaigns/:campaignId/report',
    BRAND_CAMPAIGN_PARTICIPANT = '/brand/campaigns/:campaignId/participant/:participantId',
    BRAND_AUDITION_DETAIL = '/brand/auditions/:auditionId',
    BRAND_AUDITION_PARTICIPANT = '/brand/auditions/:auditionId/participant/:participantId',
    BRAND_FIND_TALENT = '/brand/find-talent',
    BRAND_WALLET = '/brand/wallet',
    BRAND_WALLET_FUND_CALLBACK = '/brand/wallet/fund/callback',
    CONTEST_TOKEN_PAYSTACK_CALLBACK = '/contest/tokens/callback',
    BRAND_PROFILE = '/brand/profile',
    BRAND_SETTINGS = '/brand/settings',
    BRAND_SUBSCRIPTION_PAYSTACK_CALLBACK = '/brand/settings/subscription/callback',
    /** Brand Manage (content ops) under BrandDashboardLayout */
    BRAND_MANAGE = '/brand/manage',
    BRAND_MANAGE_TEAM = '/brand/manage/team',
    BRAND_MANAGE_CONTRACTS = '/brand/manage/contracts',
    BRAND_MANAGE_CONTRACT_NEW = '/brand/manage/contracts/new',
    BRAND_MANAGE_CONTRACT_DETAIL = '/brand/manage/contracts/:contractId',
    BRAND_MANAGE_CONTRACT_SIGN = '/brand/manage/contracts/:contractId/sign',
    BRAND_MANAGE_CALENDAR = '/brand/manage/calendar',
    BRAND_MANAGE_SOCIAL = '/brand/manage/social',
    BRAND_MANAGE_AI = '/brand/manage/ai-engine',
    BRAND_MANAGE_INBOX = '/brand/manage/inbox',
    BRAND_MANAGE_SETTINGS = '/brand/manage/settings',
    BRAND_MANAGE_MY_CONTRACT = '/brand/manage/my-contract',
    BRAND_MANAGE_UGC = '/brand/manage/ugc',
    /** Public contract review + signing page for invited managers */
    CONTRACT_REVIEW = '/contract/review',
    /** AdHub Meta OAuth popup callback (top-level; must not nest under /brand layout) */
    BRAND_ADHUB_CALLBACK = '/auth/adhub/callback',
    /** Public influencer UGC card (no login) */
    PUBLIC_CREATOR_PROFILE = '/creator/:userName',
    WORK_PROFILE = '/p/:userName',
    WORK_SHOP = '/workshop/:projectId?',
    PROJECT_DETAILS = '/project-details/:slug',
    /** Public Circuul / app-install referral link — records click then redirects to store/landing. */
    REFERRAL_LINK = '/r/:code',
}

export enum ROUTE_NAMES {
    ABOUT = 'about',
    WINNERS = 'winners',
    ACCOUNT = 'account',
    COMING_SOON = 'comingsoon',
    HOME = '',
    SUBMIT = 'submit',
    EXCEPTION = '*',
    API_LOADER = 'api',
    LOGIN_IN = 'login',
    REGISTER = 'register',
    PHONE_AUTHENTICATION = 'verify',
    DASHBOARD = 'dashboard',
    FORGOT_PASSWORD = 'forgotPassword',
    SETTINGS = 'settings',
    PROFILE = 'profile',
    SEARCH = 'search',
    LINKS = 'links',
    FEED = 'campaigns',
    GIG = 'gig',
    AUDITION = 'audme',
    EVENTS = 'events',
    BUZZ_BRIDGE = 'buzzbridge',
    WORK_SHOP = 'workshop',
}

export const APP_ROUTES = {
    ABOUT: '/about',
    WINNERS: '/winners',
    ACCOUNT: '/account',
    COMING_SOON: '/comingsoon',
    DISCOVER: '/discover',
    HOME: '/',
    USER: '/:profileId?',
    SUBMIT: '/submit',
    EXCEPTION: '*',
    API_LOADER: '/api',
    LOGIN_IN: '/login',
    REGISTER: '/register',
    PHONE_AUTHENTICATION: '/verify',
    DASHBOARD: '/dashboard',
    DASHBOARD_LOYALTY_ADMIN: '/dashboard/loyalty',
    FORGOT_PASSWORD: '/forgotPassword',
    SETTINGS: '/settings',
    PROFILE: '/profile',
    SPLASH: '/splash',
    LANDING: '/landing',
    DASHBOARD_EVENTS: '/dashboard/events',
    DASHBOARD_JURYDUTY: '/dashboard/jury',
    DASHBOARD_PROFILE: '/dashboard/profile',
    DASHBOARD_PROJECT: '/dashboard/project',
    DASHBOARD_SETTINGS: '/dashboard/settings',
    DASHBOARD_SUBMISSIONS: '/dashboard/submissions',
    DASHBOARD_TEAMS: '/dashboard/teams',
    DASHBOARD_HELP: '/dashboard/help',
    DASHBOARD_MAIN: '/dashboard/main',
    ESLOGIN: '/login',
    ESSIGNUP: '/signup',
    ESRESETPASSWORD: '/reset-password',
    ESNEWPASSWORD: '/new-password/:token?',
    ESDISCOVERY: '/campaigns',
    ESVIEW_CONTEST: '/campaign/:contestId?',
    ESTRENDING: '/trending',
    ESCONTEST: '/submissions',
    ESMY_VIDEOS: '/projects',
    ESCOMING_SOON: '/coming-soon',
    ESMY_PROFILE: '/:profileId?',
    ESJURY_DUTY: '/jury-duty',
    ESJURY_DUTY_REVIEW: '/jury-duty/:contestId/review',
    ESWATCH_VIDEO: '/watch',
    SANDBOX: '/sandbox',
    SANDBOX_STUDIO: '/sandbox/studio',
    SANDBOX_COURSE: '/sandbox/course/:courseId',
    SANDBOX_PLAYER: '/sandbox/course/:courseId/lesson/:lessonId',
    ESALL_CONTESTS: '/esall-contests',
    ESJOIN_CONTESTS: '/esjoin-contest',
    ESLIVE_CONTESTS: '/eslive-contests',
    ESCONTEST_ENGAGE: '/campaign-metrics/:contestId',
    ESSETTINGS: '/settings',
    TERMS_OF_USE: '/terms-of-use',
    FAQ: '/faq',
    HELP_CENTER: '/help-center',
    SHOP: '/shop',
    PRIVACY_POLICY: '/privacy-policy',
    DELETE_ACCOUNT: '/delete-account',
    COOKIE_PREFERENCE: '/cookie-preference',
    COOKIES_POLICY: '/cookies',
    SEARCH: '/search',
    VERIFY_EMAIL: '/email-verify',
    LINKS: '/links',
    TALENTS: '/talents',
    FEED: '/campaigns',
    GIG: '/gig',
    AUDITION: '/audme',
    EVENTS: '/events',
    SUBMISSIONS: '/submissions',
    PROJECTS: '/projects',
    CONTEST_SUBMISSIONS: '/campaign/:contestId/entries',
    MESSAGES: '/messages',
    MESSAGES_CONVERSATION: '/messages/:roomId',
    MANAGE_EVENT: '/event/:id/manage',
    MANAGE_CONTEST: '/campaign/:contestId/manage',
    MANAGE_SUBMISSION: '/submission/:submissionId/manage',
    BUZZ_BRIDGE: '/buzzbridge/dashboard',
    BUZZ_BRIDGE_CAMPAIGN_WORKSPACE: '/buzzbridge/dashboard/campaigns/:campaignId/participant/:participantId',
    BUZZ_BRIDGE_CAMPAIGN_SUBMIT: '/buzzbridge/dashboard/campaigns/:campaignId/participant/:participantId/submit',
    BUZZ_BRIDGE_LANDING: '/buzzbridge',
    BUZZ_BRIDGE_DETAILS: '/buzzbridge/:campaignId',
    BUZZ_BRIDGE_REWARDS: '/buzzbridge/rewards',
    BUZZ_BRIDGE_REWARDS_NETWORK: '/buzzbridge/rewards/network',
    BUZZ_BRIDGE_REWARDS_MEMBER: '/buzzbridge/rewards/network/:referralId',
    BUZZ_BRIDGE_REWARDS_REDEEM: '/buzzbridge/rewards/redeem',
    UGC_CAMPAIGN_DETAIL: '/campaigns/:campaignId',
    WORK_SHOP: '/workshop',
};
